/* eslint-disable max-len */

import { ReactNode } from 'react';
import { Badge, Popover } from 'antd';
import apiRequests from 'utils/api';
import apiRoutes from 'config/apiRoute';
import useWebSocket from 'utils/useWebSocket';
import useLiveCounter from 'utils/useLiveCounter';

interface CountRequestBadgeProps {
  children?: ReactNode;
  collapsed?: boolean;
}

const fetchNewRequestsCount = async (abortController: AbortController): Promise<number> => {
  const response = await apiRequests.get(apiRoutes.COUNTERS, {}, {}, abortController, true);

  return response.data?.requests?.per_status?.new ?? 0;
};

const CountRequestBadge = ({ children, collapsed }: CountRequestBadgeProps) => {
  const { value: count, refresh } = useLiveCounter<number>({ fetcher: fetchNewRequestsCount });

  useWebSocket({
    channelName: 'model.changes',
    listen: {
      event: '.app.models.projects.request',
      callback: refresh,
    },
  });

  if (!count) return children ? <>{children}</> : null;

  if (collapsed) {
    return (
      <Badge count={count} size="small" title="" style={{ position: 'absolute', right: '-20px', bottom: '0px' }} />
    );
  }

  if (children) {
    return (
      <Badge count={count} size="small" title="" offset={[-5, 5]}>
        {children}
      </Badge>
    );
  }

  return (
    <Popover content={<div>New requests</div>}>
      <Badge count={count} title="" />
    </Popover>
  );
};

export default CountRequestBadge;
